module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_8011.0456dea0.png";